var FormHelper = {
  enterPostDataIfExists_SELECT : function ( name, options, value ) {
    $('select[name="'+name+'"]').html('');
  },
};
